'use strict'

const state = {
    clientSocket: null,
    notifications: localStorage.getItem('notifications') ? JSON.parse(localStorage.getItem('notifications')) : []
}

const getters = {
    notifications(state) {
        return state.notifications
    }
}

const actions = {
    setClientSocket({commit}, socketIO){ 
        commit('CLIENTSOCKET', socketIO)
    },
    notify: function({commit}, notifications){
        commit('NOTIFICATIONS', notifications)
    },
    alreadyRead({commit}, notificationId){
        commit('ALREADY_READ', notificationId)
    }
}

const mutations = {
    CLIENTSOCKET(state, clientSocket) {
        state.clientSocket = clientSocket
    },
    NOTIFICATIONS(state, notifications) {
        let auxNotifications = []
        const notificationTotalQty = state.notifications.length > 1
            ? state.notifications.reduce((accum, cur) => {
                if(typeof accum === 'number') return accum + cur.length
                else return accum.length + cur.length
            })
            : state.notifications.length ? state.notifications[0].length : 0

        if(notifications.length > notificationTotalQty) localStorage.setItem('shake', 'S')
        else localStorage.setItem('shake', 'N')

        for(const notification of notifications){
            if(!auxNotifications[0]) auxNotifications[0] = []
            if(auxNotifications[auxNotifications.length - 1].length >= 50) auxNotifications[auxNotifications.length] = []

            auxNotifications[auxNotifications.length - 1].push(notification)
        }
        
        state.notifications = auxNotifications
        localStorage.setItem('notifications', JSON.stringify(auxNotifications))
    },
    ALREADY_READ(state, notificationId){
        for(let notifications of state.notifications){
            notifications = notifications.filter(n => n.ID != notificationId)
        }
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
